import React from 'react';
import InitiativesBanner from './InitiativesBanner.js';
import "../../styles/Initiatives/Initiatives.css"
import SmallTags from './SmallTags.js';
import Cards from './Cards.js';

const Initiative = () => {






return(

    <div className="initiatives">
    <InitiativesBanner/>
    <SmallTags/>
    <Cards/>
    </div>

)


}
export default Initiative;
